import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router';
import logo from '../../../assets/Logo-ECDConnect-white.svg';
import { BannerWrapper, LoadingSpinner, Typography } from '@ecdlink/ui';
import { Config } from '@ecdlink/core';
import { LanguagesModels } from './terms-types';
import LanguageSelector from '../../components/language-selector/language-selector';

export function TermsPage(props: any) {
  const [content, setContent] = useState(null);
  const history = useHistory();
  const languages = LanguagesModels;
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    languages?.find((item) => item?.locale === 'en-za')?.id
  );

  const selectedLocale = useMemo(
    () => languages?.find((item) => item?.id === selectedLanguage)?.locale,
    [languages, selectedLanguage]
  );
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append('Referer', Config.authApi);
    myHeaders.append('Content-Type', 'application/json');

    var raw = JSON.stringify({
      operationName: 'openConsent',
      variables: {
        locale: selectedLocale,
        type: 'TermsAndConditions',
      },
      query:
        'query openConsent($locale: String, $type: String) {  openConsent(locale: $locale, type: $type) {    id    name    type    description  }}',
    });
    setIsLoading(true);
    fetch(Config.graphQlApi, {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    })
      .then((response) => response.json())
      .then((result) => {
        setContent(result?.data?.openConsent[0].description);
        setErrorMessage('');
        setIsLoading(false);
      })
      .catch((error) => {
        console.log('error', error);
        setErrorMessage("There's no consent in the language selected.");
        setIsLoading(false);
      });
  }, [selectedLocale]);

  return (
    <BannerWrapper
      size="small"
      onBack={() => history.goBack()}
      onClose={() => history.push('/')}
      renderOverflow={true}
      titleOverrideRender={() => (
        <img className="mx-auto h-8" src={logo} alt="ECD Connect" />
      )}
      className="flex flex-col items-center"
    >
      <div className="h-100vh flex flex-col items-center justify-center">
        <div className="bg-adminPortalBg w-full px-12 py-4">
          <div className="justify-left my-4 mt-2 flex w-6/12 items-center gap-2">
            <Typography type={'body'} text={'Change language:'} />
            <LanguageSelector
              languages={languages}
              selectLanguage={setSelectedLanguage}
              currentLanguageId={selectedLanguage}
              disabled={false}
            />
          </div>
        </div>
        <div
          className="p-12"
          style={{
            height: '100vh' /* Adjust the height as needed */,
            overflow: ' auto',
          }}
        >
          {isLoading && (
            <LoadingSpinner
              size="big"
              className="my-12 p-4"
              spinnerColor="white"
              backgroundColor="secondary"
            />
          )}
          {content && !errorMessage && !isLoading && (
            <Typography type={'markdown'} text={content} className="w-full" />
          )}
          {errorMessage && !isLoading && (
            <Typography
              type={'markdown'}
              text={errorMessage}
              className="w-full"
            />
          )}
        </div>
      </div>
    </BannerWrapper>
  );
}

export default TermsPage;
